import { type ComputedRef, computed } from 'vue'
import { createModal } from '/@/core/elements/modal'

interface MobileGuardModalData {
  backPath: string
  previewLink: ComputedRef<string>
  reminderEnabled: boolean
}

const { api, component } = createModal<MobileGuardModalData>(
  'MobileGuardModal',
  () => import('./MobileGuardModal.vue'),
  {
    backPath: '/?trackingComponent=Mobile Block',
    previewLink: computed(() => ''),
    reminderEnabled: false,
  },
)

export const useMobileGuardModal = api
export default component
